// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3b5bn","rootSmall":"AddTileButton_rootSmall__2Wmfc"};